import type { $Fetch } from 'ofetch';
import type { BolsaGateway } from '@/application/port/out/BolsaGateway';
import type { Desconto } from '@/domain/model/Desconto';
import type { CriarBolsaCommand, AprovarBolsaCommand, RevogarBolsaCommand } from '@/domain/model/Bolsa';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway de Bolsa (commerce). Root `/api/v1/commerce/bolsas`.
 *
 * @since G.5.20
 */
export class HttpBolsaGateway implements BolsaGateway {
  private readonly base = '/api/v1/commerce/bolsas';
  constructor(private readonly client: $Fetch) {}

  async solicitar(cmd: CriarBolsaCommand): Promise<Desconto> {
    const res = await this.client<ApiResponse<Desconto>>(this.base, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
  async aprovar(id: string, cmd: AprovarBolsaCommand): Promise<Desconto> {
    const res = await this.client<ApiResponse<Desconto>>(
      `${this.base}/${encodeURIComponent(id)}/aprovar`, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
  async revogar(id: string, cmd: RevogarBolsaCommand): Promise<Desconto> {
    const res = await this.client<ApiResponse<Desconto>>(
      `${this.base}/${encodeURIComponent(id)}/revogar`, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
}
